import ApplicationController from "application_controller.js";

export default class extends ApplicationController {
  debug = false;

  connect() {
    this.log_function("connect");

    this.boundUpdateTime = this.updateTime.bind(this);
    this.boundUpdateTime();
    this.intervalId = setInterval(this.boundUpdateTime, 1000);
  }

  disconnect(){
    this.log_function("disconnect");

    clearInterval(this.intervalId);
  }

  updateTime() {
    this.log_function("updateTime");
    const options = { timeZone: "Europe/Athens", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false };
    const currentTime = new Date().toLocaleTimeString("en-US", options);

    this.element.textContent = currentTime;
  }
}
